/**
 * Check if the field is truly email or not
 *
 * BLANK PASSES (2026-09-13). isEmail is a FORMAT rule: it says "if you type something it
 * has to look like an email", not "you must type something". Only `required` makes a field
 * mandatory, and an office that wants both adds both rules. Before this, an optional email
 * field carrying isEmail could never be submitted empty — and the message the patient read
 * was "Wrong email address format", which does not tell anyone to type something.
 *
 * @param {any} fieldValue
 * @return {boolean}
 */
export default function isEmailRule(fieldValue) {
    if (fieldValue === null || fieldValue === undefined) {
        return true
    }
    if (String(fieldValue).trim() === '') {
        return true
    }

    const REGEX_RULE = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    return REGEX_RULE.test(fieldValue)
}